/** font size */
const round = (value) => Math.round(value);

const size1 = {
  key: 1,
  font10: round(10 * 0.7),
  font12: round(12 * 0.7),
  font14: round(14 * 0.7),
  font16: round(16 * 0.7),
  font18: round(18 * 0.7),
  font20: round(20 * 0.7),
  width90: round(90 * 0.7),
};

const size2 = {
  key: 2,
  font10: 10,
  font12: 12,
  font14: 14,
  font16: 16,
  font18: 18,
  font20: 20,
  width90: 90,
};

const size3 = {
  key: 3,
  font10: 12,
  font12: 14,
  font14: 16,
  font16: 18,
  font18: 20,
  font20: 22,
  width90: 95,
};

const size4 = {
  key: 4,
  font10: 14,
  font12: 16,
  font14: 18,
  font16: 20,
  font18: 22,
  font20: 24,
  width90: 100,
};

const size5 = {
  key: 5,
  font10: round(14 * 1.25),
  font12: round(16 * 1.25),
  font14: round(18 * 1.25),
  font16: round(20 * 1.25),
  font18: round(22 * 1.25),
  font20: round(24 * 1.25),
  width90: round(100 * 1.25),
};

const size6 = {
  key: 6,
  font10: round(14 * 1.5),
  font12: round(16 * 1.5),
  font14: round(18 * 1.5),
  font16: round(20 * 1.5),
  font18: round(22 * 1.5),
  font20: round(24 * 1.5),
  width90: round(100 * 1.5),
};

export const SIZE = {
  1: size1,
  2: size2,
  3: size3,
  4: size4,
  5: size5,
  6: size6,
  // 구버전 라이더앱 (3단계)
  medium: size2,
  large: size3,
  xlarge: size4,
};

export const SIZE_MEDIUM = "medium";
export const SIZE_LARGE = "large";
export const SIZE_XLARGE = "xlarge";

export const isFontSize = (value) => Boolean(SIZE[value]);
